/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import styled, { css } from 'styled-components'
import Typography, { HeadingTypes } from 'theme/basic/typography'

interface IHeadingProps {
  type?: HeadingTypes
}

const StyledHeading = styled.h1<IHeadingProps>(
  ({ type }) => css`
    ${type && Typography[type]};
  `
)

export default StyledHeading
